import * as z from "zod";

export const NewRoleSchema = z.object({
  name: z.string().min(1, "Name is required").max(64),
  description: z.string().max(256),
});
